import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type SetUserPinMutationVariables = Types.Exact<{
   params: Types.SetUserPinParams
}>

export type SetUserPinMutation = {
   __typename?: 'Mutation'
   setUserPin:
      | { __typename?: 'OTPVerificationRequired'; message?: string | null }
      | {
           __typename?: 'PinComplexityValidationFailed'
           message?: string | null
           failures: Array<string>
        }
      | { __typename?: 'PinMatchesPreviousPin'; message?: string | null }
      | {
           __typename?: 'SetUserPinResult'
           success: boolean
           expiresAt: string
           lastChangedAt: string
        }
}

export const SetUserPinDocument = gql`
   mutation SetUserPin($params: SetUserPinParams!) {
      setUserPin(params: $params) {
         ... on SetUserPinResult {
            success
            expiresAt
            lastChangedAt
         }
         ... on PinComplexityValidationFailed {
            message
            failures
         }
         ... on PinMatchesPreviousPin {
            message
         }
         ... on OTPVerificationRequired {
            message
         }
      }
   }
`
export type SetUserPinMutationFn = Apollo.MutationFunction<
   SetUserPinMutation,
   SetUserPinMutationVariables
>
export type SetUserPinMutationResult = Apollo.MutationResult<SetUserPinMutation>
export type SetUserPinMutationOptions = Apollo.BaseMutationOptions<
   SetUserPinMutation,
   SetUserPinMutationVariables
>
